const INITIAL_STATE = {
    sidebarShow: true
}

export default (state = INITIAL_STATE, action) => {
    if (action.type === 'set') {
        return { ...state, sidebarShow: action.sidebarShow }
    }
    return state
} 